import React from "react";
import CommonCard from "components-v2/kpi/common-card";
import { useQuery } from "@tanstack/react-query";
import { apiRoot } from "services/src/config";

import { HOME_CARD_CONTENT } from "@/modules/home/constants";

export default function JobCompletionScoreCard({ onClick, cardData, tagId }) {
  const { data, isLoading } = useQuery({
    queryKey: ["jc-on-time-job-completion", tagId],
    queryFn: async () => {
      const endpoint = "kpi/jc-on-time-job-completion";
      const response = await apiRoot.get(endpoint, {
        params: tagId ? { tagId } : undefined,
      });
      return response.data;
    },
  });

  const jobCompletionPercentage = data?.onTimeJobCompletionPercentage ?? 0;
  const jobsWithExtensions = data?.jobsWithExtensions ?? 0;
  const totalJobs = data?.totalJobs ?? 0;
  const onTimeJobs = data?.onTimeJobs ?? 0;

  const { title, description } = HOME_CARD_CONTENT.jobCompletionScore;

  return (
    <CommonCard
      title={title}
      info={description}
      onClick={onClick}
      cardData={{
        title: title,
        description: description,
        value: isLoading ? "0" : jobCompletionPercentage,
        unit: "%",
        details: [
          { label: "Jobs with Extensions", value: jobsWithExtensions },
          { label: "Total Jobs", value: totalJobs },
          { label: "On Time Jobs", value: onTimeJobs }
        ],
      }}
      percentage={jobCompletionPercentage}
      isLoading={isLoading}
    />
  );
}
